type SupportCategoryLike = {
  name: string;
  description: string;
};

type HelperPackLike = {
  title: string;
  description: string;
};

function matchesSupportSearch(fields: string[], term: string) {
  if (!term) {
    return true;
  }

  return fields.some((field) => field.toLowerCase().includes(term));
}

export function getSupportSearchResults<
  TCategory extends SupportCategoryLike,
  TPack extends HelperPackLike,
>(categories: readonly TCategory[], helperPacks: readonly TPack[], search: string) {
  const term = search.trim().toLowerCase();

  return {
    hasActiveSearch: term.length > 0,
    filteredCategories: Array.from(categories).filter((category) =>
      matchesSupportSearch([category.name, category.description], term),
    ),
    filteredHelperPacks: Array.from(helperPacks).filter((pack) =>
      matchesSupportSearch([pack.title, pack.description], term),
    ),
  };
}
